var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus, faXmark, faInfo } from '@fortawesome/free-solid-svg-icons';
function getIconFromStatus(status) {
    switch (status) {
        case 'success':
            return faCheck;
        case 'warning':
            return faMinus;
        case 'danger':
            return faXmark;
        default:
            return faInfo;
    }
}
function Status(props) {
    var text = props.text, status = props.status;
    var type = status;
    var icon = getIconFromStatus(status);
    return (_jsx("div", __assign({ className: 'tol-status' }, { children: _jsxs(Alert, __assign({ variant: type }, { children: [_jsx(FontAwesomeIcon, { icon: icon, size: "sm" }), _jsx("span", __assign({ className: "status-text" }, { children: text }))] }), type) })));
}
export default Status;
